<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog user-deactivate-dialog"
        top="10vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">帳號停用檢查</template>
        <div class="detail-row">
            <div class="detail-block">
                <div style="color: #aaa">停用帳號</div>
                <div class="user-info">
                    <div>
                        {{ userInfo.nam }}
                    </div>
                    <div>
                        {{ userInfo.eml }}
                    </div>
                </div>
                <div class="validate-section">
                    <div class="section-header">
                        <div class="title">
                            <div>待處理單據與設定</div>
                            <div v-if="isDeactivateDisabled" class="sub warning-text">請處理未通過項目，再執行停用。</div>
                        </div>
                        <div class="action"></div>
                    </div>
                    <div class="validate-block">
                        <!-- PASSED: 沒有設定審核流程，也沒有卡住的資料 -->
                        <DeactivateDisplayBlock
                            v-for="item in validateItems"
                            :key="item.name"
                            :type="item.data === false || item.data.length === 0 ? 'passed' : 'failure'"
                            :label="item.label"
                            :data="item.data"
                        />
                    </div>
                    <div style="display: flex; justify-content: end; margin-top: 10px;">
                        <el-button v-if="isDeactivateDisabled" type="primary" plain size="small" @click="onExport">匯出 Excel</el-button>
                    </div>
                </div>
                <div v-if="isTransferNeeded" class="transfer-section">
                    <div class="section-header">
                        <div class="title">
                            <div>主管身份轉移</div>
                            <div class="sub">停用時需要將直屬員工轉移給其他帳號。</div>
                        </div>
                    </div>
                    <div>
                        <el-tag class="staff-item" v-for="item in subordinateList" :key="item.sno">{{ item.nam }}</el-tag>
                    </div>
                    <div class="spacer-title">將轉移給</div>
                    <el-form ref="form" :model="transferForm" :rules="transferFormRules" class="target-selects">
                        <el-form-item prop="dept">
                            <el-select v-model="transferForm.dept" placeholder="選擇部門" no-data-text="無資料" @change="onSelectDep">
                                <el-option v-for="item in departmentList" :key="item.sno" :label="item.deP_NAM" :value="item.sno" />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="boss">
                            <el-select v-model="transferForm.boss" placeholder="選擇員工" no-data-text="無資料">
                                <el-option v-for="item in transferMemberList" :key="item.sno" :label="item.nam" :value="item.sno" />
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <center style="margin-bottom: 20px;">
                <el-button icon="el-icon-close" @click="onCancel">取消</el-button>
                <el-button icon="el-icon-check" type="primary" :disabled="isDeactivateDisabled || isQR()" :loading="isLoading" @click="onSubmit">確定停用</el-button>
            </center>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import DeactivateDisplayBlock from './DeactivateDisplayBlock.vue';
import ExcelMixins from './ExcelMixins';

export default {
    mixins: [ExcelMixins],
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        userInfo: {
            type: Object,
            default: () => ({}),
        },
        subordinateList: {
            type: Array,
            default: () => [],
        },
    },
    components: { DeactivateDisplayBlock },
    computed: {
        isTransferNeeded() {
            return this.subordinateList.length > 0;
        },
        isDeactivateDisabled() {
            const isFailure = _.chain(this.validateItems)
                .map((o) => ({ failure: typeof o.data === 'boolean' ? o.data : o.data.length > 0 }))
                .find(['failure', true])
                .value();

            return !!isFailure;
        },
    },
    data() {
        return {
            isLoading: false,
            validateItems: [
                {
                    name: 'auditFlowSetting',
                    label: '設定 / 審核流程設定',
                    data: false,
                },
                {
                    name: 'specialProject',
                    label: '設定 / 特別費用審核人',
                    data: [],
                },
                {
                    name: 'currentExpenditure',
                    label: '設定 / 經常性支出審核人',
                    data: [],
                },
                {
                    name: 'project',
                    label: '專案 / 擔任專案PM或經辦人',
                    data: [],
                },
                {
                    name: 'payment',
                    label: '請款單 / 待審核',
                    data: [],
                },
                {
                    name: 'invoice',
                    label: '發票 / 待審核',
                    data: [],
                },
            ],

            transferForm: {
                dept: '',
                boss: '',
            },
            transferFormRules: {
                dept: [{ required: true, message: '請選擇部門', trigger: 'change' }],
                boss: [{ required: true, message: '請選擇新主管', trigger: 'change' }],
            },
            departmentList: [],
            transferMemberList: [],
        };
    },
    methods: {
        async onOpen() {
            try {
                this.isLoading = true;
                await this.fetchValidation();
                await this.fetchTransformation();
            } catch (error) {
                console.error('Error validating deactivation:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async fetchValidation() {
            const resp = await this.$api({
                url: '/StaffManagementPage/ValidateDeactiveStaff',
                method: 'POST',
                data: { sno: this.userInfo.sno },
            });

            this.validateItems.forEach((item) => {
                const itemData = item;
                itemData.data = resp.data.items[item.name];
            });
        },
        async fetchTransformation() {
            const resp = await this.$api({
                url: '/StaffManagementPage/GetDepartmentOptions',
                method: 'GET',
            });

            this.departmentList = resp.data.options;
        },
        async onSelectDep(value) {
            this.transferForm.boss = '';
            const resp = await this.$api({
                url: `/StaffManagementPage/GetManagerOptions?sno=${value}`,
                method: 'get',
            });
            console.log(resp.data.options);
            this.transferMemberList = _.chain(resp.data.options)
                .filter((x) => x.sno !== this.userInfo.sno)
                .filter((x) => x.grP_NO !== 'SA')
                .filter((x) => x.grP_NO !== 'ADM')
                .filter((x) => x.grP_NO !== 'INI')
                .value();
        },
        onBeforeClose() {
            this.$emit('close');
        },
        onCancel() {
            this.onBeforeClose();
        },
        async onSubmit() {
            try {
                if (this.isTransferNeeded) {
                    this.$refs.form.validate(async (valid) => {
                        if (valid) {
                            try {
                                await this.$confirm('確定要停用此使用者？', {
                                    confirmButtonText: '確定',
                                    cancelButtonText: '取消',
                                });

                                this.isLoading = true;
                                await this.onTransferBoss();
                                await this.onDeactivate();
                                this.$message({
                                    showClose: true,
                                    message: '帳號已停用',
                                    type: 'success',
                                });
                                this.$router.push({ name: 'staff', query: { typ: this.userInfo.typ } });
                                return true;
                            } catch (e) {
                                console.log(e);
                            } finally {
                                this.isLoading = false;
                            }
                        }
                        return false;
                    });
                } else {
                    try {
                        await this.$confirm('確定要停用此使用者？', {
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                        });

                        this.isLoading = true;
                        await this.onDeactivate();
                        this.$message({
                            showClose: true,
                            message: '帳號已停用',
                            type: 'success',
                        });
                        this.$router.push({ name: 'staff', query: { typ: this.userInfo.typ } });
                    } catch (e) {
                        console.log(e);
                    } finally {
                        this.isLoading = false;
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        onTransferBoss() {
            return this.$api({
                url: '/StaffManagementPage/ChangeManager',
                method: 'POST',
                params: { OldSno: this.userInfo.sno, NewSno: this.transferForm.boss },
            });
        },
        onDeactivate() {
            return this.$api({
                url: '/StaffManagementPage/DeactiveStaff',
                method: 'POST',
                data: { sno: this.userInfo.sno },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.user-deactivate-dialog {

    .validate-section,
    .transfer-section {
        margin-top: 30px;

        .section-header {
            display: flex;
            justify-content: space-between;
            padding: 5px 0;
            margin: 0 0 10px 0;
            border-bottom: 1px solid #333;

            >.title {
                font-size: 13pt;
                font-weight: bold;
                text-align: left;

                >.sub {
                    font-size: 10pt;
                    font-weight: normal;
                }
            }
        }
    }

    .validate-section {
        margin-bottom: 55px;
    }

    .user-info {
        font-weight: bold;
    }
    .validate-block {
        > *:not(:last-child) {
            margin-bottom: 10px;
        }
    }

    .transfer-section {
        text-align: center;
        margin-bottom: 40px;
        .dialog-title {
            font-size: 16pt;
            font-weight: bold;
            text-align: center;
            padding: 20px 0 10px;
        }
        .spacer-title {
            font-weight: bold;
            margin: 20px 0 10px;
        }
        .target-selects {
            display: flex;
            justify-content: center;
            .el-select:first-child {
                margin-right: 12px;
            }
        }
        .staff-item {
            margin-left: 6px;

            &:first-child {
                margin-left: 0;
            }
        }
    }
    .warning-text {
        color: red;
    }
}
</style>
